import { type GetHookResponse } from '../hooks'
import { locationCountKey } from '../keys'
import { useTantalimQuery } from '../query'
import { HOUR, type LatLng, type LocationCountInput, type LocationCountSuccess } from '@terros/common'

export function useLocationCount(coordinates: LatLng[] | undefined, enabled = true): GetHookResponse<number> {
  const isEnabled = getEnabled(coordinates, enabled)
  return useTantalimQuery<LocationCountInput, LocationCountSuccess, number>({
    url: '/location/count',
    queryKey: locationCountKey(coordinates),
    input: { coordinates: coordinates ?? [] },
    convertResponse: (data) => data.count,
    options: {
      enabled: isEnabled,
      gcTime: HOUR,
      staleTime: HOUR,
      retry: false,
    },
  })
}

const getEnabled = (coordinates: LatLng[] | undefined, enabled: boolean): boolean => {
  if (!coordinates) return false
  if (coordinates.length < 3) return false
  return enabled
}
